import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import { config } from '../../../config/index';
import logo from '../../../assets/images/logos/powertrack.png';
import ToastUtil from '../../../components/ToastNotification/ToastUtil';
const { API_URL, ASSOCIATE_URL } = config;

const SetupAccount = ({ location, history }) => {
  const token = queryString.parse(location.search).token;

  const [password, setPassword] = useState('');

  const submitHandler = async (e) => {
    e.preventDefault();

    let url = `${API_URL}/account/setup`;
    try {
      let response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          password,
          for_setup: true,
        }),
        withCredentials: true,
        mode: 'cors',
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        ToastUtil.success('Password is successfully set!');
        let response_data = await response.json();

        if (response_data.data.is_associate) {
          window.location.href = ASSOCIATE_URL;
        } else {
          history.push('/');
        }
      } else {
        ToastUtil.error('Failed to set password!');
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div
      className="d-flex flex-column text-center align-items-center justify-content-center"
      style={{ height: '100vh' }}
    >
      <div
        className="container"
        style={{ position: 'relative', height: '75%', width: '350px' }}
      >
        <div className="mb-4 pb-2 mx-auto" style={{ width: '200px' }}>
          <img src={logo} style={{ width: '200px' }} alt="" />
        </div>
        <h5>Setup Account</h5>
        <form onSubmit={(e) => submitHandler(e)}>
          <input
            className="form-control mt-4 mb-2"
            type="password"
            placeholder="Set Password"
            onChange={(e) => setPassword(e.target.value)}
          />

          <button type="submit" className="btn btn-block btn-brand mt-4">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default withRouter(SetupAccount);
